<template>
    <ValidationProvider
        class="relative appearance-none"
        tag="div"
        :vid="vid"
        :rules="rules"
        :name="name"
        :mode="mode"
        v-slot="{ errors, required, ariaInput, ariaMsg }"
    >
        <input
            :style="customStyle"
            :class="[{ 'hasError': errors[0]}, inputClass]"
            :type="type"
            :placeholder="placeholder"
            ref="input"
            v-model="innerValue"
            :disabled="disabled"
            v-beautify.literal="vBeautify"
            v-bind="ariaInput"
            :autocomplete="autocomplete"
            v-units.literal="utilsLiteral"
            v-tooltip.bottom-end="{
                content: errors[0],
                template: tooltipTemplate(),
            }"
            @blur="emitBlur"
            @paste="emitPaste"
            @keyup="e => $emit('changed', e)"
        >
    </ValidationProvider>
</template>

<script>

export default {
    name: "VeeInput",
    props: {
        customStyle: {
            type: String,
            default: '',
        },
        disabled: {
          type: Boolean,
          default: false
        },
        utilsLiteral: {
            type: String,
            default: ''
        },
        vid: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            default: ""
        },
        mode: {
            type: String,
            default: "lazy"
        },
        rules: {
            type: [Object, String],
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        vBeautify: {
            default: '',
            type: String
        },
        autocomplete: {
          default: 'on',
          required: false
        },
        inputClass: {
          default: '',
          required: false
        },
        type: {
            type: String,
            default: "text",
            validator(value) {
                return [
                    "url",
                    "text",
                    "password",
                    "tel",
                    "search",
                    "number",
                    "email"
                ].includes(value);
            }
        },
        value: {
            type: null,
            default: ""
        }
    },
    data: () => ({
        innerValue: ""
    }),
    methods: {
        tooltipTemplate ()  {
            return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
        },
        emitBlur() {
          this.$nextTick(() => {
            this.$emit('blur', this.value)
          });
        },
      emitPaste(e) {
          this.$emit('paste', e.clipboardData.getData('text/plain'))
      },
    },
    watch: {
        innerValue(newVal, oldVal) {
            if (newVal !== oldVal){
                this.$emit("input", newVal);
            }
        },
        value(val) {
            if (val !== this.innerValue) {
                this.innerValue = val;
            }
        }
    },
    created() {
        if (this.value !== null && this.value !== '') {
            this.innerValue = this.value;
        }
    }
};
</script>

<style lang="scss">

.tooltip-inner.hasError {
    text-shadow: none !important;
    border-color: #d04444 !important;
    background-color: #d04444 !important;
    box-shadow: 4px 4px 8px #dd4b3973 !important;
}
.tooltip-arrow.hasError {
    border-color: #d04444 !important;
}
</style>
